import React from 'react'

const Content = ({ children }) => (
  <div className="content" style={{ position: 'relative', minHeight: '200px' }}>
    {children}
  </div>
)

export default Content
